// extracted by mini-css-extract-plugin
export var phone = "_1x-0";
export var phoneDragging = "_1x-1";